import generalUpload from "../_section/upload.class";

export class userProofOfPPSNUpload extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}
const template= {
    items: [
        {
            name: 'documentDate',
            label: 'Document Date',
            type: 'date',
        }, {
            name: 'ppsn',
            label: 'PPS Number',
            type: 'text',
        }
    ]
}
export class adminProofOfPPSNUpload extends userProofOfPPSNUpload {

    constructor(request, upload, queries) {
        super(request, upload, queries);
        this.calcValues(template)
        if (this.values.documentDate) {
            this.setDateData({
                dated: this.values.documentDate,
                expires: this.values.documentDate.add(1, 'year'),
            })
        }
    }

}
